export default {
  methods: {
    locale() {
      if (this.$i18n && this.$i18n.locale) {
        return this.$i18n.locale;
      }
      throw new Error('locale is undefined');
    },
    isChile() {
      return this.locale() === 'cl';
    }
  }
};
